import styled from "@emotion/styled";
import { MDSBannerKind } from "./banner.types";
import { Theme } from "@emotion/react";

export const StyledBanner = styled.section<{ kind?: MDSBannerKind; showDismissBtn?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["3"]};
  width: 100%;

  padding-top: ${({ theme }) => theme.spacing["2"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
  padding-left: ${({ theme }) => theme.spacing["7"]};
  padding-right: ${({ theme, showDismissBtn }) => (showDismissBtn ? 0 : theme.spacing["4"])};
  min-height: 56px; /* Enough height even without buttons */

  background-color: ${({ theme, kind }) => getBackgroundColor(theme, kind)};

  line-height: ${({ theme }) => theme.lineHeights["paragraph-s"]};
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  & p {
    margin: 0;
    color: ${({ theme, kind }) => getTextColor(theme, kind)};
  }
`;

export const StyledRightContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getBackgroundColor = (theme: Theme, kind?: MDSBannerKind) => {
  switch (kind) {
    case MDSBannerKind.Info:
      return theme.colors.background.banner.emphasis;
    case MDSBannerKind.Error:
      return theme.colors.background.banner.danger;
    default:
      return theme.colors.background.banner.default;
  }
};

const getTextColor = (theme: Theme, kind?: MDSBannerKind) => {
  switch (kind) {
    case MDSBannerKind.Error:
      return theme.colors.text.danger;
    default:
      return theme.colors.text.primary;
  }
};
